import React from "react";
import {
    EmailSubsectionChip,
    IconCustomAccess,
    PersonOutlinedChip,
    PhoneSubsectionChip
} from "../../../../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../../../../components/CustomTooltip";
import SummaryListCard from "../../../../../../../../components/Summary/SummaryListCard";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Custom access container for the shift access summary. Thin wrapper over the
 * shared SummaryListCard with email/phone chips per item.
 */
const SummaryContainerCustomAccess = ({ t, selected = [] }) => {

    const Contact = ({ item }) => (
        <div className={"row"}>
            <div className={"col-12 col-md-6 flex-row justify-content-start align-items-baseline p-0 pr-3"}>
                <div className={"mr-8px"}><EmailSubsectionChip /></div>
                <div className={"flex-grow-1 minw-0"}>
                    <CustomTooltip
                        text={item?.email}
                        classes={`fs-12px text-ellipsis-1-row`}
                        showIfTruncated={true}
                    />
                </div>
            </div>
            <div className={"col-12 col-md-6 flex-row justify-content-end align-items-baseline p-0"}>
                <div className={"mr-8px"}><PhoneSubsectionChip /></div>
                <div className={"flex-grow-1 minw-0"}>
                    <CustomTooltip
                        text={item?.phoneNumber}
                        classes={`fs-12px text-ellipsis-1-row`}
                        showIfTruncated={true}
                    />
                </div>
            </div>
        </div>
    );

    return (
        <SummaryListCard
            headerIcon={IconCustomAccess}
            title={t('custom_access')}
            emptyText={t('no_information_custom_access')}
            avatarIcon={PersonOutlinedChip}
            selected={selected}
            getKey={(item, index) => item.userId || index}
            getLabel={(item) => item.fullName}
            renderValue={(item) => <Contact item={item} />}
            t={t}
        />
    )

}

export default SummaryContainerCustomAccess
